import styled from 'styled-components';

const HR = styled.hr<{ color?: string }>`
  height: 1px;
  background-color: ${({ color }) => color || `#e5e6e8`};
  border: none;
`;

export default HR;
